import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import DialogTitle from "@mui/material/DialogTitle";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { API } from "aws-amplify";
import SkeletonLoader from "./helpers/SkeletonLoader";
import InfoAlert from "./helpers/InfoAlert";
import { EquipmentUrl } from "./EquipmentUrl";
import IconButton from "@mui/material/IconButton";
import EnergyClassA from "./svgr/EnergyClasses/EnergyClassA";
import EnergyClassB from "./svgr/EnergyClasses/EnergyClassB";
import EnergyClassC from "./svgr/EnergyClasses/EnergyClassC";
import EnergyClassD from "./svgr/EnergyClasses/EnergyClassD";
import EnergyClassE from "./svgr/EnergyClasses/EnergyClassE";
import EnergyClassF from "./svgr/EnergyClasses/EnergyClassF";
import EnergyClassG from "./svgr/EnergyClasses/EnergyClassG";
import Button from "@mui/material/Button";
import LaunchIcon from "@mui/icons-material/Launch";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { Icon, Tooltip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

export function EquipmentDetails() {
  const [equipment, setEquipment] = useState({ loading: true, data: [] });
  const theme = useTheme();
  const { serialNumber } = useParams();
  const navigate = useNavigate();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("lg"));
  const handleLogoClick = () => {
    window.location.reload();
  };

  useEffect(() => {
    setEquipment({ loading: true });
    const fetchData = async () => {
      const payload = {
        queryStringParameters: {
          serial_number: serialNumber,
        },
      };
      const data = await API.post("NFClandingAPI", "/getNFCEquipment", payload);
      setEquipment({ loading: false, data: data.length > 0 ? [data[0]] : [] });
    };

    fetchData();
  }, [serialNumber]);

  const tableData = [
    { label: "Equipment", key: "equipment_number" },
    { label: "Serial Number", key: "serial_number" },
    { label: "Description", key: "description" },
    //{ label: "Equipment Category", key: "categoria_equipment" },
    // { label: "Technical Type", key: "tipo_ogg_tecnico" },
    { label: "Producer", key: "manufacturer" },
    { label: "Year of construction", key: "serial_number_creation_year" },
    { label: "Energy Label", key: "energy_label" },
  ];

  return (
    <Grid
      container
      // spacing={2}
      justifyContent="center"
      sx={{
        minHeight: "100%",
        backgroundImage: `linear-gradient(to bottom, rgba(215, 121, 0, 1), rgba(120, 40, 0, 1)) !important;`,
      }}
    >
      <Grid item xs={12} md={6}>
        <a href="/" onClick={handleLogoClick}>
          <img
            style={{ maxWidth: "250px" }}
            alt="Epta Logo"
            src={require("../assets/img/LOGO-EptaService_White_Ho_3D_CMYK.webp")}
          />
        </a>
        <Box
          sx={{
            width: mobileDevice ? "90%" : "100%",
            marginX: "auto",
            marginTop: "1rem",
          }}
        >
          <Card sx={{borderRadius: 2}}>
            <DialogTitle sx={{paddingBottom: 0}}>
              <Tooltip title="Go back">
              <IconButton onClick={() => navigate(`/`)} sx={{ mr: 0.5 }}>
                <ArrowBackIcon />
              </IconButton>
              </Tooltip>
              Equipment Details
            </DialogTitle>
            {equipment.loading ? (
              SkeletonLoader(tableData.length)
            ) : (
              <Container
                sx={{
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      {!serialNumber && (
                        <InfoAlert
                          message={`The provided Tag Identifier is not available`}
                        />
                      )}
                      {equipment.data.length === 0 && serialNumber ? (
                        <InfoAlert
                          message={`The Equipment with Serial Number ${serialNumber.toUpperCase()} is not available`}
                        />
                      ) : (
                        equipment.data.map((e) =>
                          tableData.map((row) =>
                            row.key !== "energy_label" && (
                              <TableRow key={row.key}>
                                <TableCell
                                  sx={{
                                    fontWeight: "bold",
                                    borderRight: `1px solid rgba(224, 224, 224, 1)`,
                                  }}
                                  component="th"
                                  scope="row"
                                  align="left"
                                  width="30%"
                                >
                                  {row.label}
                                </TableCell>
                                <TableCell align="left" width="70%">
                                  {equipment.data.map((e) => e[row.key])}
                                </TableCell>
                              </TableRow>
                            )
                            // row.key === "tipo_ogg_tecnico" &&
                            // e[row.key] !== null ? (
                            //   <TableRow key={row.key}>
                            //     <TableCell
                            //       sx={{
                            //         fontWeight: "bold",
                            //         borderRight: `1px solid rgba(224, 224, 224, 1)`,
                            //       }}
                            //       component="th"
                            //       scope="row"
                            //       align="left"
                            //       width="30%"
                            //     >
                            //       {row.label}
                            //     </TableCell>
                            //     <TableCell align="left" width="70%">
                            //       {equipment.data.map((e) => e[row.key])}
                            //     </TableCell>
                            //   </TableRow>
                            // ) : (
                            //   row.key !== "energy_label" &&
                            //   row.key !== "tipo_ogg_tecnico" && (
                            //     <TableRow key={row.key}>
                            //       <TableCell
                            //         sx={{
                            //           fontWeight: "bold",
                            //           borderRight: `1px solid rgba(224, 224, 224, 1)`,
                            //         }}
                            //         component="th"
                            //         scope="row"
                            //         align="left"
                            //         width="30%"
                            //       >
                            //         {row.label}
                            //       </TableCell>
                            //       <TableCell align="left" width="70%">
                            //         {equipment.data.map((e) => e[row.key])}
                            //       </TableCell>
                            //     </TableRow>
                            //   )
                            // )
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <>
                  {equipment.data &&
                    equipment.data.length > 0 &&
                    serialNumber &&
                    equipment.data.map((row) =>
                        row.energy_label !== null ? (
                          <Button
                            sx={{
                              width: 'auto',
                              mt: 2, 
                              p: 1,
                              pl: 2,
                              display:"flex", 
                              justifyContent: "center", 
                              alignItems:"center",
                              border: "1px solid rgba(204, 204, 204,1.0)",
                              backgroundColor: 'rgba(204, 204, 204, 0.05)',
                              borderRadius: 2,
                              color: 'black',
                              shadowColor: 'rgba(0, 0, 0, 0.2)',
                              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            }}
                            variant="outlined"
                            target="_blank"
                            href={row["url"]}
                            endIcon={(() => {
                              switch (row["energy_label"]) {
                                case "A":
                                  return (
                                    <EnergyClassA
                                      sx={{ width: 80, height: 40, ml: -1, p:1 }}
                                    />
                                  );
                                case "B":
                                  return (
                                    <EnergyClassB
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                case "C":
                                  return (
                                    <EnergyClassC
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                case "D":
                                  return (
                                    <EnergyClassD
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                case "E":
                                  return (
                                    <EnergyClassE
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                case "F":
                                  return (
                                    <EnergyClassF
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                case "G":
                                  return (
                                    <EnergyClassG
                                      sx={{ width: 80, height: 40, ml: -1 }}
                                    />
                                  );
                                default:
                                  return null;
                              }
                            })()}
                          >
                            <Typography sx={{fontWeight:"bold"}}>
                              Energy label
                            </Typography>
                          </Button>
                        ) : null
                    )}
                </>
              </Container>
            )}
          </Card>
{/* 
          <Box sx={{ marginTop: "1rem", paddingBottom: "1rem" }}>
            {serialNumber && <EquipmentUrl serialNumber={serialNumber} />}
          </Box> */}
        </Box>
      </Grid>
    </Grid>
  );
}